import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: API_BASE,
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('voxipro_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('voxipro_token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const makeCall = (toNumbers) =>
    api.post("/api/outbound/make-call", { toNumbers });

export const getAllCalls = () =>
    api.get("/api/outbound/get-all-calls");

// Legacy Twilio recording URL (for old system)
export const getRecordingUrl = (callSid) => `${API_BASE}/api/outbound/recording/${callSid}`;

// New GridFS recording URL (for new system)
export const getGridFSRecordingUrl = (recordingId) => `${API_BASE}/api/recordings/${recordingId}/stream`;

// Call recording URL (alternative endpoint)
export const getCallRecordingUrl = (callId) => `${API_BASE}/api/calls/${callId}/recording`;

export default api;
